/**
 * Code utilisé par le flexible content "Recherche agence"
 */

 (function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { RechercheAgence : {}});
           
   
    /**
     * Initialisation du formulaire de recherche d'une agence
     */
    w.Kinougarde.RechercheAgence.initFormulaire = function($form) {
            
            $("#adresse").toggleIconGeoloc();

            // Clic sur le bouton trouver
            $form.find("button").on('click',function(e) {
                e.preventDefault();                
                $form.parsley().validate();
                if ($form.parsley().isValid()) {    
                    var data = {};
                    // Recupère toutes les valeurs des champs du formulaire pour les stocker dans un javascript
                    $form.serializeArray().forEach(function(value, key){
                    data[value['name']]= (typeof(value['value'])!==undefined && value['value']!=="" ? value['value'] : null)}
                    );          
                    $.ajax({
                        type     : 'POST',
                        dataType : 'json',
                        url      : ajax_kinougarde_object.ajaxurl,
                        data     : Object.assign({'action':'recherche_agence'},data),
                        success  : function (reponse) {  
                            if (reponse.success) {
                                //Redirection vers la page agence                                                            
                                document.location.href =  reponse.data.Url;
                            } else {
                                // Affiche un message d'erreur
                                var msg = Kinougarde.Form.getMessageErrorAjax(reponse);
                                $form.find(".form-group").after(msg);                                
                            }

                        },
                        error : function (error) {
                            // Affiche un message d'erreur
                            var msg = Kinougarde.Form.getMessageErrorAjax(reponse);
                            $form.find(".form-group").after(msg);                            
                        }
                    });    
                    return;                
                }
            });

            this.AfficherCarte(45,2,[]);

            //Affichage de la carte
    }


    /**
     * Affichage de la carte
     */
     w.Kinougarde.RechercheAgence.AfficherCarte = function(latitude,longitude,agences) {
        var self = this;
        googleMapsLoadedPromise.then(function() {

            self.icon = {path: "m 29.7 90 c 1.35 0 2.61 -0.6 3.51 -1.6 c 0.27 -0.3 6.57 -7.5 12.87 -17.6 c 8.82 -14.1 13.32 -26.5 13.32 -37 c 0 -18.7 -13.32 -33.8 -29.7 -33.8 s -29.7 15.1 -29.7 33.8 c 0 10.5 4.5 23 13.32 37 c 6.39 10.1 12.6 17.3 12.87 17.6 c 0.9 1 2.16 1.6 3.51 1.6 z m -12.69 -59.5 c 0 -8 5.67 -14.5 12.69 -14.5 s 12.69 6.5 12.69 14.5 s -5.67 14.5 -12.69 14.5 s -12.69 -6.5 -12.69 -14.5 z",
                fillColor     : '#D1007F',
                fillOpacity   : 1,
                strokeWeight  : 0,
                strokeOpacity : 1,                
                scale         : 0.35,                  
                anchor:  new google.maps.Point(30, 83),          
            }
                        
            const kinougardeMapStyle =
                [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.highway", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "transit", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit.station", "stylers": [ { "visibility": "on" } ] }, { "featureType": "transit.station.bus", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "stylers": [ { "color": "#aad2e3" }, { "visibility": "on" } ] } ];

            self.map = new google.maps.Map(document.getElementById("map"), {
                center: { lat: latitude, lng: longitude },
                zoom: 5,
                styles : kinougardeMapStyle,  
                streetViewControl : false,              
            });              

            var bounds = new google.maps.LatLngBounds({ lat: latitude, lng : longitude});

            //Ajout des markers
            self.markers = window.MapMarkersAgence.map((agence,i) => {                                        
                var marker = new google.maps.Marker({ map : self.map,
                    position : { lat: agence.Latitude, lng : agence.Longitude},                    
                    Url :  agence.Url,
                    icon: self.icon ,
                    optimized: false  // false pour les tests automatisés selenium                      
                }); 
                bounds.extend({ lat: agence.Latitude, lng : agence.Longitude});
                marker.addListener("click", (m)=> {    
                    self.SelectMarker(marker);
                });                
                return marker;           
            }); 
            self.map.fitBounds(bounds);                       
        });        
    }

    /**
     * Clic sur un markeur de la carte
     * @param {Marker cliqué} marker 
     */
    w.Kinougarde.RechercheAgence.SelectMarker = function(marker) {
        var self =this;
        // Redirection vers la page agence
        document.location.href = marker.Url;
    }

    
    
})(window);

jQuery(function() {
    try {
        //Bloc "Home header" de recherche de nounou
        if (jQuery("#section-recherche-agence").length>0) {               
        Kinougarde.RechercheAgence.initFormulaire(jQuery("#section-recherche-agence").find("form"));        
        };         
    }     
    catch (ex) {
        console.error(ex);
    }
});